var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag"},[_vm._t("default"),(_vm.canDelete)?_c('button',{staticClass:"delete",class:_vm.deleteButtonClass,on:{"click":function($event){return _vm.$emit('delete')}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }